
import {Component, Vue} from 'vue-property-decorator'
import {
  OrderReturnParamsDTO,
  OrderReturnDto,
} from '@/api/order'
import { Getter } from "vuex-class";
import PurchaseOrder from './PurchaseOrder.vue'
import PurchaseOrderReturn from './PurchaseOrderReturn.vue'

@Component({
  name: 'PurchaseOrderList',
  components: {
    PurchaseOrder,
    PurchaseOrderReturn
  },
  filters: {
    filterActive(active: number) {
      const typeMap = {
        0: '近60天',
        1: '近7天',
        2: '本月',
        3: '上月',
        4: '本季度',
        5: '上季度',
        6: '本年',
        7: '去年',
        8: '自定义',
      }
      return (
          typeMap[active as keyof typeof typeMap] || '时间筛选'
      )
    }
  }
})
export default class PurchaseOrderList extends Vue {
  @Getter companyId!: string
  showSelect = false
  orderStatus = 0
  // returnOrderStatusList（（1待退单审核 2待收货确认 3待退款审核 4待收款确认 5已完成 6已作废）不传默认全部订单排除7）不传默认全部订单
  // 待处理：包含“待退单审核”、“待收货确认”、“待退款审核”状态的退单
  // 未完成：包含“待退单审核”、“待收货确认”、“待退款审核”、“待收款确认”状态的退单
  orderStatusOptions = [
    { text: '全部退单', value: 0, returnOrderStatusList: [] },
    { text: '待处理', value: 1, returnOrderStatusList: [1, 2, 3] },
    { text: '未完成', value: 2, returnOrderStatusList: [1, 2, 3, 4] },
    { text: '已完成', value: 3, returnOrderStatusList: [5] },
    { text: '已作废', value: 4, returnOrderStatusList: [6] },
  ]
  result = []
  operation = 1
  operationList = []
  loading = false
  finished = false
  refreshing = false

  // 查询参数
  params: OrderReturnParamsDTO = {
    companyId: '',
    startTime: '',
    endTime: '',
    pageIndex: 1,
    pageSize: 10,
    returnOrderType: '',
    returnPayStatus: ''
  }
  orderList: OrderReturnDto[] = []
  totalRecords = 0
  orderToggle = '0' // 订货单0，退货单1

  authorityNode = -1

  created () {
    this.params.companyId = this.companyId
    if(this.$route.params.orderToggle && this.$route.params.orderToggle == '1') {
      this.changeOrderToggle('1')
    } else {
      this.changeOrderToggle('0')
    }
    this.$eventBus.$on('changeToggle', (data) => {
      this.changeOrderToggle(data)
    })
  }

  /**
   * @description: 订货单退货单切换
   * @param {*}
   * @return {*}
   */
  changeOrderToggle (type: string) {
    if (this.orderToggle === type) return
    this.orderToggle = type
    this.$eventBus.$emit('orderToggle', this.orderToggle)
  }


  /**
   * 跳转搜索界面
   */
  toSearch () {
    // topType 1 销售单 2 退货单
    // pageType 1订货单 2退货单
    let topType = this.$route.path.includes('orderList') ? '1' : '2'
    let pageType = this.orderToggle === '0' ? '1' : '2'
    if (topType === '1') {
      this.$router.push({
        path: '/searchOrder',
        query: {
          pageType,
          topType,
          authorityNode: `${this.authorityNode}`
        }
      })
    } else {
      this.$router.push({
        path: '/searchOrder',
        query: {
          pageType,
          topType,
        }
      })
    }
  }
}
